import { render, staticRenderFns } from "./InvoiceFormTab.vue?vue&type=template&id=6c82f03a&scoped=true"
import script from "./InvoiceFormTab.vue?vue&type=script&lang=js"
export * from "./InvoiceFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82f03a",
  null
  
)

export default component.exports